import { render, staticRenderFns } from "./broker-financials-index.vue?vue&type=template&id=4d5a2972"
import script from "./broker-financials-index.vue?vue&type=script&lang=js"
export * from "./broker-financials-index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports